import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';

// From public/css/lib/bootflow

// Basic Colors

export const veryLightGreyBackground = createRgbaColor('fafafa');
export const smokeGrey = createRgbaColor('e6e6e6');
export const lightGreyBackground = createRgbaColor('dddddd');
export const lightGreyBackgroundActive = createRgbaColor('C8C8C8');
export const lightGreyForeground = createRgbaColor('999');
export const lightRedBackground = createRgbaColor('ffdede');

//Typography
export const textColor = createRgbaColor('333333');
//Links

export const linkButtonColor = createRgbaColor('3898EC'); // Blue
export const linkButtonColorActive = createRgbaColor('2079C6'); // Dark Blue
export const linkTextColor = createRgbaColor('0082f3'); // Blue. Has to be a brighter blue because it is thinner.
export const linkTextColorActive = createRgbaColor('00549d'); // Dark Blue

export const linkTextColorBlack = createRgbaColor('222222'); // Used on Navs and Dropdowns
